<template>
  <ValidationObserver ref="formControversy">
    <form novalidate @submit.prevent="save">
      <div class="row">
        <div class="col-8">
          <BreadCrumb :page="page" />
        </div>
        <div class="col-4 text-right">
          <ActionButton
            i="fas fa-arrow-circle-left"
            variant="outline-success m-2"
            @click="back"
          >
            Regresar
          </ActionButton>
          <ActionButton
            v-if="canSetToPending"
            i="fas fa-undo"
            variant="outline-success m-2"
            @click="setToPending()"
          >
            Remover a Pendiente
          </ActionButton>
          <ActionButton
            v-if="controversyData && !isControversyResolvedOrSubmitted"
            i="fas fa-flag"
            variant="outline-success m-2"
            @click="save(true)"
          >
            Someter
          </ActionButton>
          <ActionButton
            v-if="controversyData && !isControversyResolvedOrSubmitted"
            i="fas fa-save"
            variant="success m-2"
            type="submmit"
          >
            Guardar
          </ActionButton>
        </div>
        <div class="col-12">
          <div class="dropdown-divider pb-2 w-100 mb-4" />
          <div class="tab-content">
            <div class="col">
              <ControversyErrorBox
                message="Información Incompleta"
                :is-visible="hasValidationError"
              />
            </div>
            <div class="col">
              <ControversyList
                v-if="controversyData"
                :title="
                  'Partes del PEI que están en controversia (puede marcar más de una opción)'
                "
                :submitted="isControversyResolvedOrSubmitted"
                :items="controversyList"
                :mode="mode"
                :required="missingAnswer"
              />
            </div>
            <div v-if="mode !== 'resolution'" class="col">
              <ControversyList
                v-if="controversyData"
                :title="'Información Adicional'"
                :submitted="isControversyResolvedOrSubmitted"
                :items="list"
                :show-display-number="false"
              />
            </div>
            <div class="col">
              <SectionTitle content="I. Documentos del PEI" :has-line="true" />
              <DocumentManager
                v-if="controversyData"
                :id="peiId"
                :submitted="isControversyResolvedOrSubmitted"
                :methods="methods"
                :menu-actions="menuItems"
                :allowed-files="allowedFiles"
                :required-document-types="requiredDocumentTypes"
                :document-code-type="documentCodeType"
                :disable-duplicated-types="[28, 29]"
                :exclude-documents-type="excludeFromDocumentsType"
				canShowSave
                class="document-manager-container"
                :custom-error-msg="
                  missingDocument
                    ? 'Favor de anejar el documento de tipo Minuta - Controversia'
                    : ''
                "
                @getSavedDocuments="getSavedDocuments"
              />
            </div>
            <div v-if="mode !== 'resolution'" class="col separator">
              <ControversyAgreement
                v-if="controversyData"
                :is-terms-accepted="terms"
                :disabled="isControversyResolvedOrSubmitted"
                :is-required="hasValidationError"
                @termsChecked="termsChecked"
              />
            </div>
            <div
              v-if="controversyData && !isControversyResolvedOrSubmitted"
              class="col separator"
            >
              <div class="float-right mt-4">
                <ActionButton
                  i="fas fa-save"
                  variant="success m-2"
                  type="submmit"
                >
                  Guardar
                </ActionButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { ActionButton } from '@/components/common';
import BreadCrumb from '@/components/common/page/TitleBreadcrumb';
import { SectionTitle } from '@/components/pei/shared';
import DocumentManager from '@/components/common/documents/Documents';
import mixAlert from '@/mixin/alert.mixin';
import resourcesService from '@/services/resources.js';
import {
  ControversyList,
  ControversyAgreement,
  ControversyErrorBox,
} from '@/components/pei/controversy/components';
import store from '@/store/index';
import peiStatuses from '@/utils/constants/pei/peiStatus';

const SectionVIII = 7;

export default {
  mixins: [mixAlert],
  components: {
    BreadCrumb,
    ActionButton,
    SectionTitle,
    ControversyList,
    ControversyAgreement,
    ControversyErrorBox,
    DocumentManager,
    ValidationObserver,
  },
  data() {
    return {
      peiStatusCode: null,
      peiId: store.getters.SelectedPei,
      page: {
        icon: 'fas fa-user-edit',
        title: 'PEI: Controversia',
        routes: ['Inicio', 'PEI', 'Controversia', 'PEI'],
        sections: ['I. Documentos de la Controversia'],
      },
      methods: {
        fetch: `api/pei/attachments/${store.getters.SelectedPei}`,
        upload: `api/pei/uploaddocument`,
        update: `api/pei/updatedocument`,
        delete: `/api/pei/deletedocument?id=`,
      },
      menuItems: [
        {
          iconClass: 'fas text-green fa-file-alt mr-1',
          method: 'downloadFile',
          text: 'Descargar',
        },
        {
          iconClass: 'fas text-green fa-pencil-alt mr-1',
          method: 'editFile',
          text: 'Editar',
        },
        {
          iconClass: 'fas text-red fa-times-circle mr-1',
          method: 'showConfirmationDelete',
          text: 'Eliminar',
          dataAttributes: {
            'data-toggle': 'modal',
            'data-target': '#popup',
          },
        },
      ],
      documentCodeType: 'PeiControversyDocument',
      allowedFiles: '.pdf',
      requiredDocumentTypes: [28, 178],
      excludeFromDocumentsType: [
        this.$route.params.mode !== 'resolution' ? 29 : 28,
      ],
      addNewDocument: false,
      hasValidationError: false,
      missingDocument: false,
      missingAnswer: false,
      controversyList: [],
      additionalInfoList: [],
      documentsList: [
        {
          id: 1,
          date: '31/ene/2020',
          type: 'Minuta - Controversia',
          title: 'Documento del PEI',
          comment: 'Comentario sobre el documento del PEI.',
        },
        {
          id: 2,
          date: '31/ene/2020',
          type: 'Minuta - Controversia',
          title: 'Documento del PEI',
          comment: 'Comentario sobre el documento del PEI.',
        },
        {
          id: 3,
          date: '31/ene/2020',
          type: 'Minuta - Controversia',
          title: 'Documento del PEI',
          comment: 'Comentario sobre el documento del PEI.',
        },
      ],
      documentTypeList: [{ id: 1, title: 'PEI Document' }],
      controversyData: [],
      terms: false,
      resources: [],
      documents: [],
      mode: this.$route.params.mode || 'controversy',
      isControversyResolvedOrSubmitted: false,
    };
  },
  created() {
    this.loadControversyList();
    this.loadResources();
  },
  computed: {
    list: function() {
      return this.additionalInfoList;
    },
    canSetToPending() {
      return (
        this.controversyData &&
        this.controversyData.isSubmitted &&
        this.peiStatusCode != null &&
        this.peiStatusCode != peiStatuses.Cancelado &&
        this.peiStatusCode != peiStatuses.Firmado &&
        this.peiStatusCode != peiStatuses.SignedWithControversy
      );
    },
  },
  methods: {
    termsChecked(value) {
      this.terms = value;
    },
    onAddDocumentHandler() {
      this.addNewDocument = true;
    },
    onSaveDocumentHandler(item) {
      this.addNewDocument = false;
      this.documentsList.push({
        id: this.documentsList[this.documentsList.length - 1].id + 1,
        date: '31/ene/2020',
        type: item.type.title,
        title: 'Documento del PEI',
        comment: item.comment,
      });
    },
    getSavedDocuments(documents) {
      this.documents = documents;
    },
    getMenuItems(isSubmitted) {
      this.menuItems = isSubmitted ? this.menuItems.filter((x) => x.text === 'Descargar') : this.menuItems;
    },
    loadControversyList() {
      this.$ApiGet(`/api/pei/${this.peiId}/controversies`)
        .then((res) => {
          this.controversyData = res.data;
          this.controversyData.currentPeiId = this.peiId;
          this.peiStatusCode = res.data.peiStatusId;
          this.isControversyResolvedOrSubmitted =
          this.mode !== 'resolution' ? res.data.isSubmitted : res.data.isResolved;
          this.terms = res.data.isSubmitted;
          this.getMenuItems(res.data.isSubmitted);
          this.additionalInfoList = [
            {
              id: 1,
              number: 1,
              title: '¿El PEI fue aprobado parcialmente?',
              answer: res.data.peiPartiallyApprovedAnswer,
              comment: '',
              parentQuestion: null,
            },
            {
              id: 2,
              number: 2,
              title:
                'El PEI aprobado parcialmente, ¿requería servicios relacionados?',
              answer:
                res.data.peiPartiallyApprovedAnswer !== null &&
                res.data.peiPartiallyApprovedAnswer === true
                  ? res.data.relatedServiceRequiredAnswer
                  : null,
              comment: '',
              parentQuestion: {
                relatedQuestionId: 1,
                relatedValue: res.data.peiPartiallyApprovedAnswer,
                requiredValue: true,
              },
            },
            {
              id: 3,
              number: 3,
              title:
                'El PEI aprobado parcialmente, ¿continuó recibiendo servicios relacionados?',
              answer:
                res.data.peiPartiallyApprovedAnswer !== null &&
                res.data.peiPartiallyApprovedAnswer === true
                  ? res.data.continuedRelatedServiceAnswer
                  : null,
              comment: '',
              parentQuestion: {
                relatedQuestionId: 1,
                relatedValue: res.data.peiPartiallyApprovedAnswer,
                requiredValue: true,
              },
            },
          ];

          let _list = this.mode === 'resolution' ? 
              res.data.peiControversySections.filter((x) => x.peiControversySectionId > 0) : 
              res.data.peiControversySections;
          
          this.controversyList = [];
          _list.forEach((element) => {
            let serviceSectionDescription = '';
            if (element.sectionId == SectionVIII) {
              serviceSectionDescription = `Documente la controversia relacionada a la parte ${element.sectionName} del PEI`;
              if (element.servicesList.length > 0) {
                serviceSectionDescription = `Si la controversia en la parte ${element.sectionName} es con los Servicios Relacionados, seleccione cuales:`;
              }
            }

            let partOfPei = {
              id: element.sectionId,
              peiControversySectionId: element.peiControversySectionId,
              number: element.sortOrder,
              displayNumber: `${element.sectionName}`,
              title: `${element.sectionDescription}`,
              requireErrorCode: '',
              requireErrorMessage: 'Favor de contestar si existe controversia.',
              fields: [],
              answer: element.sectionControversyAnswer,
              comment: element.sectionControversyComment,
              serviceSectionDescription: serviceSectionDescription,
              viewSectionControversyComment:
                element.viewSectionControversyComment,
              resolvedControversyList: element.resolvedControversyList,
              parentQuestion: null,
            };

            if (element.servicesList != null) {
              let counter = 1;
              element.servicesList.forEach((service) => {
                partOfPei.fields.push({
                  description: service.description,
                  id: `${service.id}-${counter}`,
                  selected: service.selected,
                });
                counter++;
              });
            }

            this.controversyList.push(partOfPei);
          });
        })
        .catch((err) => {
          this.response = err;
        });
    },
    back() {
      this.$router.push({ path: '/pei/detail' });
    },
    async save(isSubmitting) {
      const isValid = await this.$refs.formControversy.validate();
      if (isValid) {
        this.hasValidationError = false;
        isSubmitting = isSubmitting || false;
        let _mlist = this.controversyList.filter((e) => e.answer == true);
        let _list = [];

        _mlist.forEach((e) => {
          let section = this.controversyData.peiControversySections.find(
            (r) => r.sectionId == e.id
          );

          if (section) {
            section.sectionControversyAnswer = e.answer;
            section.sectionControversyComment = e.comment;
            section.servicesList = e.fields.map(field => { return { ...field, id: parseInt(field.id.split('-')[0], 10)}; });
            _list.push(section);
          }
        });

        this.controversyData.peiControversySections = _list;

        if (this.mode !== 'resolution') {
          this.controversyData.peiPartiallyApprovedAnswer = this.additionalInfoList.find(
            (e) => e.id === 1
          )?.answer;
          this.controversyData.relatedServiceRequiredAnswer = this.additionalInfoList.find(
            (e) => e.id === 2
          )?.answer;
          this.controversyData.continuedRelatedServiceAnswer = this.additionalInfoList.find(
            (e) => e.id === 3
          )?.answer;
        }

        let areCommentsValid = this.validateComments();

        if (!areCommentsValid) {
          this.ShowToast(
            'Alerta',
            'Favor de entrar la razón de la controversia.',
            'error'
          );
          return;
        }
        let validationAnswerResult =
          this.mode === 'resolution'
            ? this.validateResolutionAnswers()
            : this.validateAnswers();

        if (!validationAnswerResult) {
          this.ShowToast('Alerta', this.resources['0397'], 'error');
          this.missingAnswer = true;
          this.hasValidationError = true;
          return;
        } else {
          this.missingAnswer = false;
          this.hasValidationError = true;
        }

        if (!this.validateControversySection()) {
          this.ShowToast(
            'Alerta',
            'Debe especificar al menos una sección en controversia',
            'error'
          );
          return;
        }

        if (this.mode !== 'resolution') {
          if (this.controversyData.peiPartiallyApprovedAnswer === null) {
            this.ShowToast('Alerta', this.resources['0397'], 'error');
            return;
          } else {
            if (this.controversyData.peiPartiallyApprovedAnswer) {
              if (
                this.controversyData.relatedServiceRequiredAnswer === null ||
                this.controversyData.continuedRelatedServiceAnswer === null
              ) {
                this.ShowToast('Alerta', this.resources['0397'], 'error');
                return;
              }
            }
          }
        }
        if (isSubmitting) {
          let attachmentTypeCode = this.mode !== 'resolution' ? 28 : 29;

          if (
            !this.documents ||
            !this.documents.some(
              (e) => e.attachmentTypeCode == attachmentTypeCode
            )
          ) {
            this.ShowToast(
              'Alerta',
              `Anejar un documento del tipo ${
                attachmentTypeCode === 28
                  ? 'Minuta - Controversia'
                  : 'Minuta - Resolución Controversia'
              } es requerido para guardar la controversia.`,
              'error'
            );
            this.missingDocument = true;
            return;
          } else {
            this.missingDocument = false;
          }

          if (!this.terms && this.mode !== 'resolution') {
            this.hasValidationError = true;
            this.ShowToast(
              'Alerta',
              'Debe aceptar los terminos y condiciones.',
              'error'
            );
            return;
          } else {
            this.hasValidationError = false;
          }

          this.controversyData.isSubmitted = true;
          this.isControversyResolvedOrSubmitted = true;
        }

        let url =
          this.mode === 'resolution'
            ? `/api/pei/${store.getters.getPeiInfo.previousPeiId}/controversies/resolve`
            : `api/pei/${this.peiId}/controversies`;

        if (!this.missingDocument) {
          this.$ApiPost(url, this.controversyData)
            .then(() => {
              this.ShowToast(
                '',
                'Las respuestas fueron guardadas satisfactoriamente',
                'success'
              );
            })
            .catch(() => {
              this.controversyData.isSubmitted = false;
              this.isControversyResolvedOrSubmitted = false;
            });
        }
      } else {
        this.hasValidationError = true;
      }
    },
    validateResolutionAnswers() {
      let validation = false;
      this.controversyList.forEach((x) => {
        validation = x.resolvedControversyList.some((e) => e.selected);
        this.$set(x, 'isValid', validation);
      });
      return validation;
    },
    validateAnswers() {
      // Returns true when everything is fullfiled.
      return this.controversyList.every((e) => e.answer !== null);
    },
    validateControversySection() {
      // Returns true when at least one section has controversy.
      return this.controversyList.some((e) => e.answer === true);
    },
    validateComments() {
      // Returns true if a question is answered yes and has an explanation comment.
      return this.controversyList
        .filter((e) => e.answer === true)
        .every((e) => e.comment !== '' && e.comment !== null);
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages(['0397']);
    },
    async setToPending() {
      const isResolution = this.mode === 'resolution' ? true : false;
      await this.$ApiPost(
        `/api/pei/${this.peiId}/controversysettopending/${isResolution}`
      );
      this.loadControversyList();
    },
  },
};
</script>

<style scoped>
.btn-tabHeader {
  font-size: 0.9em;
  margin-right: 10px;
  margin-top: 1px;
}

.btn-tabHeader-outline {
  font-weight: 500;
  margin-right: 20px;
  padding-bottom: 3px;
  padding-top: 4px;
}

.btn-tab-group {
  padding-right: 20px;
}

#btnHistory {
  height: 38px;
  border: 1px solid #2db782;
  color: #2db782;
}

#btnHistory:hover {
  background: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}

.separator {
  margin-top: 60px;
}

.document-manager-container >>> .thead-property {
  border-radius: 5px 5px 0px 0px;
}
</style>
